import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import InfoModal from '../../../common/InfoModal'
import { setPaymentError } from '../../../../reducers/programRegistrationReducer'
import { ReactComponent as WarningIcon } from '../../../../assets/images/common/icons/warning-icon.svg'

const PaymentErrorModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const paymentError = useSelector(state => state.programRegistration.paymentError)

  return (
    <InfoModal
      showModal={!!paymentError}
      closeModal={() => dispatch(setPaymentError(null))}
      icon={<WarningIcon />}
      title={t('programs.registration.checkoutStep.paymentFailedTitle')}
      buttonMessage={t('common.close')}
    >
      <p className='mx-4'>{paymentError}</p>
    </InfoModal>
  )
}

export default PaymentErrorModal
